import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import Typography from "@mui/material/Typography";
import { Link, useListContext } from "react-admin";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import formatTitleText from "../unit/formatTitleText";

const AppMenuTitle = ({ ...props }) => {
  let showChip = props?.showChip ?? true;
  const type = props.type;
  let showMenuTitle = type;
  if (showMenuTitle == "Paid-Off") {
    showMenuTitle = "Paid Off Last 12 Months";
  } else if (showMenuTitle == "Charged-Off") {
    showMenuTitle = "Charged Off";
  } else if (showMenuTitle == "Late") {
    showMenuTitle = "Delinquent < 30D";
  } else if (showMenuTitle == "large30D") {
    showMenuTitle = "Delinquent > 30D";
  } else if (showMenuTitle == "delinquentPastMaturity") {
    showMenuTitle = "Delinquent Past Maturity";
  }
  const appCounts = props.count;
  let statusColor:
    | "default"
    | "primary"
    | "warning"
    | "error"
    | "secondary"
    | "info"
    | "success" = "default";
  if (showMenuTitle.includes("Current")) {
    statusColor = "primary";
  } else if (showMenuTitle.includes("Late") || showMenuTitle.includes("30D")) {
    statusColor = "warning";
  } else if (
    showMenuTitle.includes("60D") ||
    showMenuTitle.includes("90D") ||
    showMenuTitle.includes("Delinquent Past Maturity")
  ) {
    statusColor = "error";
  } else if (
    showMenuTitle.includes("Transfer Failed") ||
    showMenuTitle.includes("Insufficient Balance") ||
    showMenuTitle.includes("Funding Source Removed")
  ) {
    statusColor = "error";
  } else if (
    showMenuTitle == "Maturing < 0 M" ||
    showMenuTitle == "Maturing in 12 M" ||
    showMenuTitle == "Maturing in 12-24 M" ||
    showMenuTitle == "Maturing in 24-36 M" ||
    showMenuTitle == "Maturing in 36-48 M" ||
    showMenuTitle == "Maturing in 48-60 M" ||
    showMenuTitle == "Maturing in > 60 M"
  ) {
    statusColor = "primary";
  } else if (showMenuTitle == "Paid-Off with Credit Balance") {
    statusColor = "error";
  }
  if (showMenuTitle == "Current with 0 Resets") {
    showChip = false;
  }
  return (
    <Box component="span" sx={{ width: "100%", display: "inline-block" }}>
      {/* {formatTitleText(showMenuTitle)} */}
      {showMenuTitle}
      {showChip && (
        <Chip
          component="span"
          label={appCounts}
          size="small"
          color={statusColor}
          className="numericText"
          sx={{
            ml: 1,
            float: "right",
            fontFamily: hmLightTheme?.palette?.numberFontFamily,
          }}
        />
      )}
    </Box>
  );
};

const LoanListAside = ({ ...props }) => {
  const { filterValues } = useListContext();
  const status = filterValues?.status;
  const curStatus = filterValues?.curStatus;
  const filterRemainingterm = filterValues?.filterRemainingterm;
  const totalData = props.totalData;
  const curBank = localStorage.getItem("bank");
  const admin = localStorage.getItem("authrole");
  //如果curBank == ircceo 或者 nolb 或者 admin == 'admin' 则是isAchBank = true
  const isAchBank =
    curBank === "ircceo" || curBank === "nolb" || admin === "admin";
  return (
    <>
      <HmSubHeaderTitle
        title="Loans"
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1 }}>
          <MenuList component="div" id="list-loan-menus">
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Attention Required
            </Typography>
            {isAchBank ? (
              <>
                {/* Funding Source Removed */}
                <CustomMenuItemLink
                  to='/loans?filter={"status":"active","curStatus":"Funding Source Removed"}'
                  onClick={() => {
                    props.onChange("Funding Source Removed");
                  }}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Funding Source Removed"
                      count={totalData?.fundingSourceRemoved}
                      showTooltip={false}
                    />
                  }
                  tooltipProps={{
                    title: "Funding source removed",
                    children: <></>,
                  }}
                  selected={
                    curStatus === "Funding Source Removed" ? true : false
                  }
                />

                {/* Insufficient Balance */}
                <CustomMenuItemLink
                  to='/loans?filter={"status":"active","curStatus":"Insufficient Balance"}'
                  onClick={() => {
                    props.onChange("Insufficient Balance");
                  }}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Insufficient Balance"
                      count={totalData?.insufficientBalance}
                    />
                  }
                  tooltipProps={{
                    title: "Insufficient balance",
                    children: <></>,
                  }}
                  selected={curStatus === "Insufficient Balance" ? true : false}
                />
                {/* Transfer Failed */}
                <CustomMenuItemLink
                  to='/loans?filter={"status":"active","curStatus":"Transfer Failed"}'
                  onClick={() => {
                    props.onChange("Transfer Failed");
                  }}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Transfer Failed"
                      count={totalData?.transferFailed}
                    />
                  }
                  tooltipProps={{
                    title: "Transfer failed",
                    children: <></>,
                  }}
                  selected={curStatus === "Transfer Failed" ? true : false}
                />
                <CustomMenuItemLink
                  to='/loans?filter={"status":"active","curStatus":"delinquentPastMaturity"}'
                  onClick={() => {
                    props.onChange("delinquentPastMaturity");
                  }}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="delinquentPastMaturity"
                      count={totalData?.delinquentPastMaturity}
                    />
                  }
                  tooltipProps={{
                    title: "Delinquent Past Maturity",
                    children: <></>,
                  }}
                  selected={
                    curStatus === "delinquentPastMaturity" ? true : false
                  }
                />
              </>
            ) : (
              <>
                <CustomMenuItemLink
                  //  to="javaScript:void(0);"
                  to="/#"
                  disabled={true}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Funding Source Removed"
                      count={totalData?.fundingSourceRemoved}
                      showChip={false}
                    />
                  }
                  tooltipProps={{
                    title: "Funding source removed",
                    children: <></>,
                  }}
                  selected={
                    curStatus === "Funding Source Removed" ? true : false
                  }
                />

                {/* Insufficient Balance */}
                <CustomMenuItemLink
                  to="/#"
                  disabled={true}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Insufficient Balance"
                      count={totalData?.insufficientBalance}
                      showChip={false}
                    />
                  }
                  tooltipProps={{
                    title: "Insufficient balance",
                    children: <></>,
                  }}
                  selected={curStatus === "Insufficient Balance" ? true : false}
                />
                {/* Transfer Failed */}
                <CustomMenuItemLink
                  to="/#"
                  disabled={true}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Transfer Failed"
                      count={totalData?.transferFailed}
                      showChip={false}
                    />
                  }
                  tooltipProps={{
                    title: "Transfer failed",
                    children: <></>,
                  }}
                  selected={curStatus === "Transfer Failed" ? true : false}
                />
                <CustomMenuItemLink
                  to="/#"
                  disabled={true}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="delinquentPastMaturity"
                      count={totalData?.delinquentPastMaturity}
                      showChip={false}
                    />
                  }
                  tooltipProps={{
                    title: "Delinquent Past Maturity",
                    children: <></>,
                  }}
                  selected={
                    curStatus === "delinquentPastMaturity" ? true : false
                  }
                />
              </>
            )}

            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              By Loan Status
            </Typography>
            {isAchBank ? (
              <>
                <CustomMenuItemLink
                  to='/loans?filter={"status":"active","curStatus":"large30D"}'
                  onClick={() => {
                    props.onChange("large30D");
                  }}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle type="large30D" count={totalData?.large30D} />
                  }
                  tooltipProps={{ title: "Delinquent > 30d", children: <></> }}
                  selected={curStatus === "large30D" ? true : false}
                />
                <CustomMenuItemLink
                  to='/loans?filter={"status":"active","curStatus":"Late"}'
                  onClick={() => {
                    props.onChange("Late");
                  }}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle type="Late" count={totalData?.late} />
                  }
                  tooltipProps={{ title: "Delinquent < 30d", children: <></> }}
                  selected={curStatus === "Late" ? true : false}
                />
              </>
            ) : (
              <>
                <CustomMenuItemLink
                  to="/#"
                  disabled={true}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="large30D"
                      count={totalData?.large30D}
                      showChip={false}
                    />
                  }
                  tooltipProps={{ title: "Delinquent > 30d", children: <></> }}
                  selected={curStatus === "large30D" ? true : false}
                />
                <CustomMenuItemLink
                  to="/#"
                  disabled={true}
                  state={{ _scrollToTop: true }}
                  primaryText={
                    <AppMenuTitle
                      type="Late"
                      count={totalData?.late}
                      showChip={false}
                    />
                  }
                  tooltipProps={{ title: "Delinquent < 30d", children: <></> }}
                  selected={curStatus === "Late" ? true : false}
                />
              </>
            )}

            <hr className="thinner" />
            {/* <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK6"}'
              onClick={() => {
                props.onChange("OK6");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Current with > 6 Resets"
                  count={totalData?.ok6}
                />
              }
              tooltipProps={{
                title: "Current with > 6 resets",
                children: <></>,
              }}
              selected={curStatus === "OK6" ? true : false}
            /> */}
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK36"}'
              onClick={() => {
                props.onChange("OK36");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  // type="Current with 3-6 Resets"
                  type="Current with > 3 Resets"
                  count={totalData?.ok36}
                />
              }
              tooltipProps={{
                title: "Current with > 3 resets",
                children: <></>,
              }}
              selected={curStatus === "OK36" ? true : false}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK3"}'
              onClick={() => {
                props.onChange("OK3");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Current with < 3 Resets"
                  count={totalData?.ok3}
                />
              }
              tooltipProps={{
                title: "Current with < 3 reset",
                children: <></>,
              }}
              selected={curStatus === "OK3" ? true : false}
            />
            <CustomMenuItemLink
              disabled
              className="menuTitle"
              to="/#"
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Current with 0 Resets"
                  count={totalData?.ok}
                />
              }
            />
            {/* no need this list, it should be include on Delinquent < 30 D,
            and no need care about the spring bank,because we don't have more info for sp loan */}
            {/* <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":"<0 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Maturing < 0 M" count={totalData?.ok_0} />
              }
              tooltipProps={{ title: "Maturing < 0 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == "<0 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            /> */}
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":"<12 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Maturing in 12 M"
                  count={totalData?.ok_12}
                />
              }
              tooltipProps={{ title: "Maturing in 12 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == "<12 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":"12-24 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Maturing in 12-24 M"
                  count={totalData?.ok_12_24}
                />
              }
              tooltipProps={{ title: "Maturing in 12-24 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == "12-24 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":"24-36 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Maturing in 24-36 M"
                  count={totalData?.ok_24_36}
                />
              }
              tooltipProps={{ title: "Maturing in 24-36 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == "24-36 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":"36-48 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Maturing in 36-48 M"
                  count={totalData?.ok_36_48}
                />
              }
              tooltipProps={{ title: "Maturing in 36-48 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == "36-48 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":"48-60 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Maturing in 48-60 M"
                  count={totalData?.ok_48_60}
                />
              }
              tooltipProps={{ title: "Maturing in 48-60 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == "48-60 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"OK", "filterRemainingterm":">60 Months"}'
              onClick={() => {
                props.onChange("OK");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Maturing in > 60 M"
                  count={totalData?.ok_60}
                />
              }
              tooltipProps={{ title: "Maturing in > 60 M", children: <></> }}
              selected={
                curStatus == "OK" && filterRemainingterm == ">60 Months"
                  ? true
                  : false
              }
              sx={{ "&.MuiMenuItem-root": { pl: 6 } }}
            />

            <hr className="thinner" />

            {/* <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"30D"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="30D" count={totalData?.d30} />}
              tooltipProps={{ title: "30D", children: <></> }}
              selected={curStatus === "30D" ? true : false}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"60D"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="60D" count={totalData?.d60} />}
              tooltipProps={{ title: "60D", children: <></> }}
              selected={curStatus === "60D" ? true : false}
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"active","curStatus":"90D"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="90D" count={totalData?.d90} />}
              tooltipProps={{ title: "90D", children: <></> }}
              selected={curStatus === "90D" ? true : false}
            /> */}
            <CustomMenuItemLink
              to='/loans?filter={"status":"Charged-Off"}'
              onClick={() => {
                props.onChange("Charged-Off");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Charged-Off Last 12 Months"
                  count={totalData.chargedOff}
                />
              }
              tooltipProps={{
                title: "Charged-off Last 12 Months",
                children: <></>,
              }}
              selected={status === "Charged-Off" ? true : false}
            />
            <hr className="thinner" />
            <CustomMenuItemLink
              to='/loans?filter={"status":"Paid-Off","curStatus":"creditBalance"}'
              onClick={() => {
                props.onChange("Paid-Off");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Paid-Off with Credit Balance"
                  count={totalData.paidOff_creditBalance}
                />
              }
              tooltipProps={{
                title: "Paid-off with Credit Balance",
                children: <></>,
              }}
              // selected={status === "Paid-Off"  ? true : false}
              selected={
                status === "Paid-Off" && curStatus === "creditBalance"
                  ? true
                  : false
              }
            />
            <CustomMenuItemLink
              to='/loans?filter={"status":"Paid-Off"}'
              onClick={() => {
                props.onChange("Paid-Off");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Paid-Off Last 12 Months"
                  count={totalData.paidOff}
                />
              }
              tooltipProps={{
                title: "Paid-off Last 12 Months",
                children: <></>,
              }}
              // selected={status === "Paid-Off" ? true : false}
              selected={status === "Paid-Off" && !curStatus ? true : false}
            />
            <hr className="thinner" />

            <CustomMenuItemLink
              to='/loans?filter={"status":"Voided"}'
              onClick={() => {
                props.onChange("Voided");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Voided Last 12 Months"
                  count={totalData.voided}
                />
              }
              tooltipProps={{ title: "Voided Last 12 Months", children: <></> }}
              selected={status === "Voided" ? true : false}
            />
            <hr />
            <CustomMenuItemLink
              to={`/reports?filter={"status":"Inception to Date","reportType":"loans"}`}
              state={{ _scrollToTop: true }}
              primaryText={"Download More Loan Data"}
              sx={{ "& .MuiTypography-root": { color: "#1976d2" } }}
            />
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default LoanListAside;
